/**
 * @fileoverview POSTWS handler for the "/users/subscription_group_current_day_stats/(:subscription_group_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupCurrentDayStatsSubscriptionGroupId } from "./constants";
import type {
  PostwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdPayload,
  PostwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdProps,
} from "./types";
import { isUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdResult } from "./validators";

export const postwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupId = reactQueryPostWebsocketAdapter(
  usersSubscriptionGroupCurrentDayStatsSubscriptionGroupId,
  async (
    signal,
    {
      timeout = 180000,
      jobToken,
      estimated,
      ...props
    }: PostwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdProps
  ): Promise<{}> => {
    const payload: PostwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdPayload = {
      ...props,
      timeout,
      job_token: jobToken,
      estimated,
    };
    return fetch(`/users/subscription_group_current_day_stats/${props.subscriptionGroupId}`, "POST", payload, {
      signal,
    });
  },
  isUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdResult
);
